import React from 'react';
import { CTAButton } from './CTAButton';
import { priceFraming } from '../data/content';
export function FinalCTA() {
  return <section className="w-full bg-terracotta-dark px-5 py-16 text-center sm:px-8 sm:py-20" data-id="element-79" data-mp="3udozgq2ltkph">
      <div className="mx-auto max-w-2xl" data-id="element-80" data-mp="c7k61z6m2ppe">
        <h2 className="font-display text-2xl font-black uppercase leading-tight text-cream sm:text-4xl" data-id="element-81" data-mp="c4fvmk2jyxqa">
          Empezar hoy puede cambiar lo que terminás mañana
        </h2>
        <p className="mx-auto mt-4 max-w-xl font-sans text-base leading-relaxed text-cream/85" data-id="element-82" data-mp="m340si9fvick">
          Son 8 minutos por día, sin depender de la fuerza de voluntad.
        </p>
        <p className="mx-auto mt-2 max-w-xl font-display text-lg font-bold italic text-gold sm:text-xl" data-id="element-83" data-mp="vtgj03ts6zfj">
          Terminá lo que empezás, sin esperar a tener disciplina.
        </p>
        <p className="mx-auto mt-6 max-w-md rounded-2xl border border-cream/25 px-5 py-4 font-sans text-sm leading-relaxed text-cream/90" data-id="element-84" data-mp="14uoc87hfxa2r">
          {priceFraming.comparisonLong}
        </p>
        <div className="mt-8 flex justify-center" data-id="element-85" data-mp="2c5g5o456wyuw">
          <CTAButton size="lg" className="bg-plum shadow-[0_8px_0_0_#25131F] hover:bg-plum-deep hover:shadow-[0_5px_0_0_#25131F]" data-id="element-86" data-mp="2c6rb08eaaeo4">
            Quiero mi guía ahora
          </CTAButton>
        </div>
        <p className="mt-4 font-sans text-xs font-semibold uppercase tracking-[0.14em] text-cream/70" data-id="element-87" data-mp="2r1nmcuhe3i5f">
          Acceso inmediato a la guía · Todos los bonos incluidos
        </p>
      </div>
    </section>;
}